<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";
import getQrCode from "../../../helpers/qrCode";
import FileServices from "../../../services/files_export.js";
import { swal } from "../../../helpers/handle_error.js";

export default {
  page: {
    title: "أستمارة المشاركات الفنية",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة المشاركات الفنية",
          href: "/form/artist",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],
      uri: "form-artist/getFile",

      id: this.$route.params.id,
      loadingContent: true,
      loadingButtonDownload: null,
      loadingButtonView: null,
      formArtist: null,
      showAlert: false,

      //allowed file open in browser.
      allowedFile: [
        'jpg',
        'jpeg',
        'png',
        'pdf',
      ],
    };
  },
  computed: {
    ...mapGetters("formArtist", ["getArtist"]),
  },
  methods: {
    getQrCode,
    ...mapActions("formArtist", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    handleErrorFile(error) {
      if (FileServices.axios.isCancel(error)) {
        // Request was canceled
        alert("Request canceled", error);
      } else {
        try {
          this.showAlert = true;
          if (error.response.status == 422)
            this.errors = Object.values(error.response.data.errors);
          else
            this.errors = [
              `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
            ];
        } catch (error) {
          swal.error("لا يمكن تحميل الملف");
        }
      }
      this.loadingButtonDownload  = null;
      this.loadingButtonView      = null;
    },
    allowedFileOpen(extension){
      return this.allowedFile.includes(extension.toString().toLowerCase().trim())
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.formArtist = this.getArtist;
          this.loadingContent = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
    viewAttachment(index, path) {
      this.loadingButtonView = index;
      let params = { path: path };

      FileServices.download(this.uri, { params: params, responseType: "blob" })
        .then((response) => {
          FileServices.responseBlobOpen(response);
          this.loadingButtonView = null;
        })
        .catch((error) => {
          this.handleErrorFile(error);
        });
    },
    downloadAttachment(index, path, fileName = "") {
      this.loadingButtonDownload = index;
      let params = { path: path };

      FileServices.download(this.uri, { params: params, responseType: "blob" })
        .then((response) => {
          FileServices.responseBlobDownload(response, fileName);
          this.loadingButtonDownload = null;
        })
        .catch((error) => {
          this.handleErrorFile(error);
        });
    },
    cancelView() {
      FileServices.cancelDownload();
    },
    cancelDownload() {
      FileServices.cancelDownload();
    },
    // copyLink
    copyLink(link) {
      navigator.clipboard.writeText(link).then(() => {
        this.$bvToast.toast("تم نسخ الرابط!", {
          title: "تم",
          variant: "success",
          solid: true,
          autoHideDelay: 2000,
        });
      });
    },
    formatFileSize(size) {
      const i = Math.floor(Math.log(size) / Math.log(1024));
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "KB", "MB", "GB", "TB"][i]
      );
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <div class="title-separator"><h4>المعلومات الاساسية :</h4></div>
            <div class="row about-list mb-5">
              <h5 class="name">الاسم : {{ formArtist.full_name }}</h5>
              <div class="col-md-4">
                <div class="media">
                  <label>الاسم الفني :</label>
                  <p>{{ formArtist.artistic_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ formArtist.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ formArtist.gender.name_ar }}</p>
                </div>
                <div class="media">
                  <label>البريد الالكتروني :</label>
                  <p>{{ formArtist.email }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ formArtist.education_level.name_ar }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي :</label>
                  <p>{{ formArtist.study_specialization }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف (1) :</label>
                  <p>{{ formArtist.phone1 }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف (2) :</label>
                  <p>{{ formArtist.phone2 }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الدولة :</label>
                  <p>{{ formArtist.country.name_ar }}</p>
                </div>
                <div class="media">
                  <label>المدينة :</label>
                  <p>{{ formArtist.province }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التقديم :</label>
                  <p>{{ formArtist.created_at }}</p>
                </div>
              </div>
            </div>

            <div class="title-separator"><h4>معلومات المشاركة :</h4></div>
            <div class="row about-list mb-5">
              <div class="col-md-12">
                <div role="tablist" class="tablist">
                  <b-card
                    no-body
                    class="mb-1 shadow-none"
                    v-for="(artist, index) in formArtist.artists"
                    :key="artist.id"
                  >
                    <b-card-header header-tag="header" role="tab">
                      <h5 class="m-0">
                        <a
                          v-b-toggle="'accordion-' + index"
                          class="text-dark"
                          href="javascript: void(0);"
                          ><span>{{ index + 1 }}</span
                          >{{ artist.artwork_name }}</a
                        >
                      </h5>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + index" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="media">
                                <label>القسم الرئيسي :</label>
                                <p>{{ artist.sub.main.name_ar }}</p>
                              </div>
                              <div class="media">
                                <label>المحور الفرعي :</label>
                                <p>{{ artist.sub.name_ar }}</p>
                              </div>
                              <div class="media">
                                <label>اسم العمل :</label>
                                <p>{{ artist.artwork_name }}</p>
                              </div>
                              <div class="media">
                                <label>الملاحظات :</label>
                                <p>{{ artist.note }}</p>
                              </div>
                            </div>
                            <div class="col-md-6 con-file">
                              <b-form-group
                                v-if="artist.attachments.length > 0"
                                label="ملف العمل :"
                                label-for="file-link"
                              >
                                <div class="file-size-type">
                                  <p><strong>الحجم : </strong> {{ formatFileSize(artist.attachments[0].size) }}</p>
                                  <p><strong>النوع : </strong> {{ artist.attachments[0].extension }}</p>
                                </div>
                                <b-input-group-append class="mb-3">
                                  <b-button
                                    class="w-50 btn-download"
                                    variant="primary"
                                    @click="
                                      downloadAttachment(
                                        index,
                                        artist.attachments[0].path,
                                        artist.artwork_name
                                      )
                                    "
                                    :disabled="loadingButtonDownload != null || loadingButtonView != null"
                                    >
                                    <b-spinner
                                      v-if="loadingButtonDownload == index"
                                      small
                                    ></b-spinner>
                                    <p v-else>
                                      تنزيل الملف<i
                                        class="bx bx-download font-size-16 align-middle mx-1"
                                      ></i>
                                    </p>
                                  </b-button>
                                  <b-button
                                    class="w-50 btn-view"
                                    variant="info"
                                    @click="viewAttachment(index, artist.attachments[0].path)"
                                    :disabled="loadingButtonView != null || loadingButtonDownload != null || !allowedFileOpen(artist.attachments[0].extension)"
                                  >
                                    <b-spinner v-if="loadingButtonView == index" small></b-spinner>
                                    <p v-else>
                                      عرض الملف<i
                                        class="bx bx-link-external font-size-16 align-middle mx-1"
                                      ></i>
                                    </p>
                                  </b-button>
                                </b-input-group-append>
                              </b-form-group>

                              <b-form-group
                                v-if="artist.link != null && artist.link.trim() != ''"
                                label="الرابط الاضافة :"
                                label-for="file-link"
                              >
                                <b-input-group class="mb-2">
                                  <b-form-input
                                    id="file-link"
                                    :value="artist.link"
                                    readonly
                                    ref="fileLinkInput"
                                  ></b-form-input>
                                  <b-input-group-append>
                                    <b-button
                                      class="btn-copy"
                                      @click="copyLink(artist.link)"
                                      variant="secondary"
                                      >نسخ<i
                                        class="bx bx-copy font-size-16 align-middle mx-1"
                                      ></i
                                    ></b-button>
                                    <b-button
                                      class="btn-go"
                                      :href="artist.link"
                                      target="_blank"
                                      variant="primary"
                                      >انتقال<i
                                        class="bx bx-link font-size-16 align-middle mx-1"
                                      ></i
                                    ></b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>

            <div class="title-separator"><h4>وصل التسجيل :</h4></div>
            <div class="row about-list">
              <div class="col-md-12">
                <QrCodeCard
                  title="أستمارة المشاركات الفنية"
                  :fullName="formArtist.full_name"
                  :date="formArtist.created_at"
                  :Id="formArtist.serial_number"
                  :artists="formArtist.artists"
                  :qrCodeContent="this.getQrCode(formArtist.uuid, formArtist.from_lang)"
                ></QrCodeCard>
              </div>
            </div>

            <div class="">
              <hr />
              <router-link :to="{ name: 'form.artist' }">
                <b-button class="w-100 btn-rounded" type="button" variant="secondary"
                  >رجوع</b-button
                >
              </router-link>
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
